import React, { FunctionComponent, PropsWithChildren, useEffect } from 'react'
import { getMetricsPublisherChainAsync } from '@amzn/aapn-front-end-metrics'
import { useLocation } from 'react-router-dom'

// Events can be XOR'ed together
export enum MetricEvent {
  None = 0,
  Click = 1 << 0,
}

export const ClickMetricsProvider: FunctionComponent = (props: PropsWithChildren<{}>) => {
  const location = useLocation()

  useEffect(() => {
    // string regex match will return null if nothing is matched.
    // Will return an array with first element being the whole string following by capture group if matched.
    const partnerIdFromPathname = location.pathname.match(/\/partners\/directory\/(?:details|contact)\/([^/]*)/)

    const clickEventCapture = (e: MouseEvent): void => {
      if (e.target) {
        const target = e.target as HTMLElement
        const dataId = target.getAttribute('data-id')
        if (MetricEvent.Click & (parseInt(target.getAttribute('data-publish-metrics') ?? '0') as MetricEvent) && dataId) {
          getMetricsPublisherChainAsync('click').then(p => {
            p.publishCounter(dataId, 1)
            p.publishString('id', dataId)
            if (partnerIdFromPathname) {
              p.publishString('partnerId', partnerIdFromPathname[1])
            }
          })
        }
      }
    }

    window.addEventListener('click', clickEventCapture, false)

    return () => {
      window.removeEventListener('click', clickEventCapture)
    }
  }, [location])

  return <>{props.children}</>
}
